var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancelExecute(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 6H12.5V3",
    stroke: "#4281C9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6H7.5C7.2 6 7 5.8 7 5.5C7 5.2 7.2 5 7.5 5H10.5C10.8 5 11 5.2 11 5.5C11 5.8 10.8 6 10.5 6Z",
    fill: "#4281C9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 8H7.5C7.2 8 7 7.8 7 7.5C7 7.2 7.2 7 7.5 7H11.5C11.8 7 12 7.2 12 7.5C12 7.8 11.8 8 11.5 8Z",
    fill: "#4281C9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 10H7.5C7.2 10 7 9.8 7 9.5C7 9.2 7.2 9 7.5 9H13.5C13.8 9 14 9.2 14 9.5C14 9.8 13.8 10 13.5 10Z",
    fill: "#4281C9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 12H7.5C7.2 12 7 11.8 7 11.5C7 11.2 7.2 11 7.5 11H10.5C10.8 11 11 11.2 11 11.5C11 11.8 10.8 12 10.5 12Z",
    fill: "#4281C9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 3.5H3.5V16.5H12.3",
    stroke: "#4281C9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 11.5C14.9 11.5 15.2 11.6 15.5 11.7V5.5L12.5 2.5H5.5V14.5H11.5C11.5 12.8 12.8 11.5 14.5 11.5Z",
    stroke: "#4281C9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 17.5C16.1569 17.5 17.5 16.1569 17.5 14.5C17.5 12.8431 16.1569 11.5 14.5 11.5C12.8431 11.5 11.5 12.8431 11.5 14.5C11.5 16.1569 12.8431 17.5 14.5 17.5Z",
    fill: "#FF0000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8 13.8L15.2 15.2",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2 13.8L13.8 15.2",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelExecute);
export default __webpack_public_path__ + "static/media/cancelExecute.623fb260a9ef0bdfa0853c42db75ec96.svg";
export { ForwardRef as ReactComponent };